import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { ecaPlatformApps } from "../ecaModulesData";
import { ecaPlatformIconMap } from "../ecaModuleIcons";

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const EcaWhatWeProvideSection: React.FC = () => (
  <section className="wdev-why" aria-labelledby="eca-provide-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2 id="eca-provide-title" className="wdev-section-head__title">
          What We Provide
        </h2>
        <p className="eca-section-lead">
          End-to-end e-commerce ecosystem — shopping apps, vendor tools, admin control, and seller mobile access.
        </p>
      </AnimatedSection>

      <div className="wdev-why__grid eca-platform-grid">
        {ecaPlatformApps.map((app, index) => {
          const Icon = ecaPlatformIconMap[app.icon];
          return (
            <motion.article
              key={app.title}
              className="wdev-why-card eca-platform-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.25 } }}
            >
              <div className="wdev-why-card__icon">
                <Icon size={24} strokeWidth={1.75} aria-hidden="true" />
              </div>
              <h3 className="eca-platform-card__title">{app.title}</h3>
              <p className="eca-platform-card__desc">{app.description}</p>
            </motion.article>
          );
        })}
      </div>
    </div>
  </section>
);

export default EcaWhatWeProvideSection;
